module.exports = {"title":"Plano cancelado","text":"A solicitação de cancelamento foi enviada. Entraremos em contato com você nos próximos dias para confirmar o cancelamento. Até lá, você pode continuar utilizando o seu Veloe com acesso livre aos locais conveniados. Enquanto isso, guarde o número do protocolo: ","protocol":"18U3187388","helmetTitle":"plano cancelado","date":"Salvo em 10/10/2017 às 19:30"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/CancelPlanConfirmation/data.json
// module id = 2160
// module chunks = 0